import { cn } from "../../lib/utils";
import { PlaceTypeIcon } from "../ui/icons/place-type-icons";
import { IconBadge } from "../ui/icon-badge";
import type { SearchResultItem } from "./types";

interface SearchResultListItemProps {
  item: SearchResultItem;
  index: number;
  isActive: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
}

export function SearchResultListItem({ item, index, isActive, onClick, onMouseEnter }: SearchResultListItemProps) {
  return (
    <li
      id={`search-option-${index}`}
      role="option"
      aria-selected={isActive}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      className={cn("mx-1.5 flex cursor-pointer items-center gap-3 rounded-lg px-2.5 py-2 transition-colors", {
        "bg-accent": isActive,
        "hover:bg-muted": !isActive,
      })}
    >
      <IconBadge className="p-1.5" aria-hidden="true">
        <PlaceTypeIcon type={item.placeType} className="size-4" />
      </IconBadge>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-foreground">{item.name}</p>
        <p className="truncate text-xs text-muted-foreground">{item.subtitle}</p>
      </div>
    </li>
  );
}
